import styled from "@emotion/styled";

import { focusOutlineStyle } from "metabase/core/style/input";

export const LinkRoot = styled.a`
  ${focusOutlineStyle("brand")};
`;
